import WifiOffIcon from "@mui/icons-material/WifiOff";
import { Button, Stack } from "@mui/material";
import { type FC, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Offline.scss";

type OfflineProps = {
  onRetry?: () => void;
  onContinue?: () => void;
};

export const Offline: FC<OfflineProps> = ({ onRetry, onContinue }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const from =
    (location.state as { from?: string } | null)?.from || "/volunteers";

  const leaveOffline = useCallback(() => {
    if (onContinue) {
      onContinue();
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(from, { replace: true });
  }, [from, navigate, onContinue]);

  const retry = useCallback(() => {
    if (onRetry) {
      onRetry();
      return;
    }
    if (navigator.onLine) leaveOffline();
  }, [leaveOffline, onRetry]);

  useEffect(() => {
    const handleOnline = () => {
      if (!navigator.onLine) return;
      retry();
    };

    window.addEventListener("online", handleOnline);
    const poll = window.setInterval(handleOnline, 2000);
    handleOnline();

    return () => {
      window.removeEventListener("online", handleOnline);
      window.clearInterval(poll);
    };
  }, [retry]);

  return (
    <div className="offline-container">
      <WifiOffIcon />
      אין לך אינטרנט
      <Stack direction="row" gap={1} flexWrap="wrap" justifyContent="center">
        <Button variant="contained" onClick={retry}>
          נסה שוב
        </Button>
        <Button variant="outlined" onClick={leaveOffline}>
          חזרה
        </Button>
      </Stack>
    </div>
  );
};
